<template>
    <div class="form-group">
        <label class="full">LOGO</label>

        <div class="d-flex">
            <img :src="'/static/images/auth/' + this.placeholder + '.jpg'" alt="Click to add a picture" @click.prevent.stop="uploadPhoto" class="avatar pointer" v-if="!newImageBase64">
            <div v-if="newImageBase64" class="avatar" @click.prevent.stop="uploadPhoto" :style="{ 'background-image': 'url(' + newImageBase64 + ')' }"></div>
            <!-- <img :src="newImageBase64" v-if="newImageBase64" class="avatar pointer" @click.prevent.stop="uploadPhoto"> -->
            <div class="ml-3">
                <ul class="fs-small bold darker mb-4">
                    <li>Minimum dimensions: 300x300px</li>
                    <li :class="{'color-6': !isSizeOk}">Max. file size: 1MB</li>
                    <li :class="{'color-6': !isFormatOk}">JPG or PNG only</li>
                </ul>

                <button @click.prevent.stop="uploadPhoto" class="btn secondary wide">Upload Logo</button>

                <input type="file" class="hidden" ref="inputAvatarUpload" @change="receiveImage" />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            placeholder: {
                type: String,
                default: 'agent'
            },
            loadThisImage: {
                default: null
            }
        },
        data: function() {
            return {
                newImageBase64: null,
                sizeLimit:1, // in Mb
                validTypes:[
                    'image/jpeg',
                    'image/png'
                ],
                isSizeOk: true,
                isFormatOk: true,
            }
        },
        created: function () {
            if(this.loadThisImage){
                this.newImageBase64 = this.loadThisImage
            }
        },
        methods: {
            uploadPhoto: function() {
                this.$refs.inputAvatarUpload.click();
            },
            receiveImage: function(event) {
                let vm = this;
                var reader = new window.FileReader() // if window is not used it says File READER is not defined

                // validate
                this.isFormatOk = this.validateType(event.target.files[0].type, this.validTypes)

                this.isSizeOk = this.validateSize(event.target.files[0].size, this.sizeLimit)

                if(this.isFormatOk && this.isSizeOk){
                    reader.onload = function (event) {

                      // dispatch fileAttached to state UI postEditor with event.target.result as read dataURL
                      let imageDataBase64 = event.target.result
                      vm.newImageBase64 = imageDataBase64;

                      vm.$emit('uploadComplete', imageDataBase64);
                    }
                    reader.readAsDataURL(event.target.files[0])
                }

                //debug
                //console.log(event.target.files[0]);
            },
            validateType: function(receivedType, validTypesArr) {
                let output = false;
                for (let validType of validTypesArr) {
                    if (receivedType == validType) {
                        output = true;
                    }
                }
                return output
            },
            validateSize: function(givenSize, validSize){
                let sizeInMb = givenSize / (1024*1024);
                return sizeInMb <= validSize
            }
        },
    }
</script>

<style scoped lang="scss">
.avatar{
    width: 120px;
    height: 120px;
    background-position: center center;
    background-size: cover;
}
</style>



// WEBPACK FOOTER //
// AvatarUploader.vue?5d6f821e